<template>
  <div class="sidebar-main">
    <ul class="menu">
      <li class="list item" @click="newCvs('template')">
        <img src="https://files.wondercv.com/new-cv-icon.png" alt="">
        <div class="con">
          <p class="title">新建简历</p>
          <p class="msg">选择高分简历模板</p>
        </div>
        <i class="iconfont iconchevron-right"></i>
      </li>
      <li class="list item" @click="newCvs('import')">
        <img src="https://files.wondercv.com/import-cv-icon.png" alt="">
        <div class="con">
          <p class="title">导入简历</p>
          <p class="msg">上传简历智能优化</p>
        </div>
        <i class="iconfont iconchevron-right"></i>
      </li>
    </ul>
    <div class="menu" v-for="(opt, index) in list" :key="index">
      <sidebar-item
        v-for="item in opt"
        :key="item.name"
        :item="item"
        :font-weight="item.fontWeight"
        :iconfont-img="item.icon"
        :iconfont-class="item.iconFont"
        :text="item.name"
        :flag="item.name === sidebar"
        :num="item.num"
        :isNew="!!item.isNew"
        @click="routerTo(item.alertType, item.url, item.push, item.target)"/>
    </div>
    <planning-resume-select @close="selectState = false" v-if="selectState"/>
  </div>
</template>
<script>
const img1 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAC90lEQVRoQ+1Yv0t6URT/WENEQUlghDUVZtEaTTW05qb9AdoS4iJSIIUNtggWLUU05NJUDjq5OJnQIG2hLTZZNFg6JBSUxrkQhD947/ae31dfzlkcPOee+zmfez7v3mNqNBoN/MdmYoB/nF1m8I8TCGaQGfzlFeAj+ssJUtweM6hYol/uwAz+hCC6v6fTaWSzWTw8POD9/b1lmZ6eHoyNjWF+fh4OhwO9vb0/SaUY0xUGT05OcHV1pZj8y8Fut2NzcxMmk0l1jFpH3QHe3Nxgb28PAwMDWF9fx8zMTFt2iOVisYjj42M8PT3B4/FgcXFR7b5V++kO8Pz8HKlUCi6XCysrK4obIaaJ8YWFBVEQvU13gEdHR8jlcvB6vaK/lIxY3N3dxdTUFLa2tpTcpf83HODd3R3C4TAmJyexvb0tDUApQBog9c7l5SXy+bzoneaJx+PjI2q1GkZHRzE4OKiUH29vbyiVSujr68P4+HiLv9lshs1mw/Ly8o+UVgrgx8cHotEobm9vFTeut8PExASCwSD6+/ullpYCmEwmkUgkMDIyAqfTCYvF0iLt8XgchUJB/D87O6u4mfv7e5yensJqtQolbbbn52eRk/yWlpbgdrsV1/zuIAWQeoQSkRiQKLQzWZFR04PUChsbG4K9w8PD7gFcW1tDvV4XFe/0Ue4GQELk9/tRrVZxcHCAoaEh1SClGPw6HrFYrGOCbgEMBAKg47q/vw8SHrXGAL9XihkEwEe0qXnUqCiFcA92UB0WGRaZpqPBIsMi014tWEVZRVXcXvmq9tevavToLJfLiEQi4jX/rx68r6+v8Pl8oGk4zVHpV61J3WToHZjJZDA9PS3GC+1A6v0dpEfu2dkZrq+vMTc3J+6kMiYF8OXlBaFQCJVKRSaHLr40rtjZ2RHTOhmTAkgLE8iLiwsxNqTj2m0bHh4WJ2Z1dVUMu2RNGqBsAqP9GaDRDGjNzwxqraDR8cyg0Qxozc8Maq2g0fHMoNEMaM3PDGqtoNHxn/LmHIYOm6hQAAAAAElFTkSuQmCC';
const img2 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAEYUlEQVRoQ+1ZSyhtYRRex3PgESHEhDzLO0wMREIpAynKQIy8yzuGYkRCBuRVJGWiTJR3mXokJCKG3u/k7fat29a5x7Xv+c/Z9+7jtv/J7pzz//9a33rtb62je39/f6f/eOk0gN/cu5oHv7kDSfOg5kELt4AWohbuoD+qp3nwjyay8A1meXBjY4NmZmbo4OCA7u7uFIOq0+nI0dGR/P39KS0tjUJDQ02+2ySAj4+PNDo6SktLSyYLNvYgwCYlJVFubi7Z2toae+xjn0kABwcHGZyNjQ1bODIykjw9PQnKKLHQ4BwdHdHa2hpNT0/T29sbpaSkUF5envD1wgARlu3t7Qyuvr6eAgIChIWKHNje3qa2tjYCaMgLDg4WOS5O1QAOIDMyMig7O/uTsNvbW7K3tyc7OzshReQ2Ix1mZ2cpNjaWSktLhe4V9mB5eTkXlMbGRgoMDPxF2MXFBVvZxcWFWltbhRSR27y1tcVedHNz46fIEgZYUFDA93d1dZGTk9Mvsvb29qilpYW/GxoaEtFDdu/Z2RnV1tZyZPT09Ajd+y0Anp+fU01NjToAd3d3aWxsjJ6fn+np6YlOT0/Zwj4+PvzE+6yoqIjDVlqoit3d3XRycvJbb1hZWXF1TkhI4N9VBTgxMUGTk5OyYVNdXU1hYWEfe66urqiyslL2TExMDCHfVQf48PBAy8vL9PLywh6ZmppipfLz8/np4ODA1c/wHYnCIXnbECn2RkREkKurq/oA9ZX7W0VG1RDVB7i/v0/Nzc2KV1GLAfj6+koDAwPk5eVFmZmZQuVcbrPFAFQMkcFFGkAZyyr6otc8aKIFVA9REGsQ7aqqKvLw8GAYm5ub1Nvby81qVlaWidB+HlMVIConWAnaJLB9dBPHx8dMxkHfwsPDGbj+AiloamqSpWqowunp6eoDhAaHh4fcHt3f3zP7QDsFcL6+vlRXV/ep67i5uWGjgJN+teLj46m4uNgyABqCxGeQbXjTsKWSAGEkgTbodwtUDb2m1DSrGqKSgsg5KSzxnRSuUk4aAllZWZHloiDb0lnVAeqD8/b2puvraw7Xr0BeXl5+yktDA0RHR1NFRYX6IYoiU1ZWRugqpJyDxaWcDAkJ4VDVXxgg9fX1fVlkEKKpqakUFxf37wEWFhbyhKuzs5OcnZ1Zgf7+fi7lJSUlHzmHwgNempiYyCM/cxbaKhSrfzKyQNjgldDQ0EBBQUHm6G30WWlU6e7uLjzMEqZqHR0dtL6+zu+onJwco5U0Z+Pw8DAtLCxwyCJKRJYwQAxikV/IEwyCzPnfwBhFYUykA+QhakQHzcIAodTIyAjNz88ThkPJyckUFRWl6OgeBABsaHV1lRYXFznnTY0YkwCCpYyPj9Pc3BwL/5sLRkRFxRTd2tpaWJRJACUpOzs7PFJX+u8z3A8G5Ofnx+BEw1LfCmYBFDanCgc0gCoYXVGRmgcVNacKl2keVMHoiorUPKioOVW4TPOgCkZXVOR/78Ef0JAxhrWmchoAAAAASUVORK5CYII=';
const img3 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAC4klEQVRoQ+1YMUhyURT+VCQQQyuEWhrDQReXclBwabHBybBBkwYnB3F2as7FqUHShrSmBl1ahBzUxaUGcXRRiKJIBBX151540e/vr/c90W5yz/Qe73v3nO985557OarRaDTCCptKEPzl6goFf7mAEAoKBTnPgChRzgWaGZ5QcGaKOAcIBTkXaGZ4QsH/pej9/R23t7eo1Wogz4s0o9EIs9mM4+NjkGc5pkhBQigWi6HdbsvxNTdWr9fj/PxcFklFBBOJBKrVKqxWK05PT7G5uTl38NMWeHt7QyqVwtPTE2w2G8LhMLM/RQTPzs4wHA7hcrng8/mg1WqZHSoB9no9ZLNZFAoFqNVqJJNJ5mUUEQwGg18OTCYT/H4/LBYLs1M5wOfnZ1xfX+Pl5eXrt6urK+Yl5iK4u7uLRqNBndntdqrm+vo6s/NpwM/PT2QyGZRKJQr77mtpBEmpPDw84P7+Ht1uF6QJeL1eOByOuUgWi0Xc3d3RJra2tgaPx4PDw0OQrUFsaQQlR6+vr0in07QJECMtPRAIYHt7WxbRVqtF1yFHDzHSxMg6W1tb9F3aGksnKLGoVCq0rD4+PmjjcbvdODo6gkajmUp0MBggl8shn8+j3+/DYDDQct/f3//rvx8nSKLpdDq0vB4fH0FGrjs7O/Qo2dvbm0iyXq/TI6DZbEKlUsHpdNIy1+l0/+C5IChFNStwuYngokTHUz6p9E5OTijs5uZGdilzpeB3suPNQ/omtxlxS1AiJLV/8q7kOOGeICFGuiQxJde7X0FQ1sE4BhYEJ2RvrruonBvFPMpJ/woFhYKMdaSkVBiXngpT4lfswUkpjUQidJJ2cXGx8HmM5J/MZaLRKDY2NhCPx5kLQpGCl5eXKJfLPzJ0Ojg4QCgUWizBlR8bkvSt9OCXuT44ACragxzEzRyCIMicKk6BQkFOhWEOSyjInCpOgUJBToVhDksoyJwqToFCQU6FYQ5r5RX8A1+nR3dVoEy+AAAAAElFTkSuQmCC';;
const menu1 = [
  {
    icon: 'https://files.wondercv.com/cv-icon.png',
    name: '我的简历',
    flag: false,
    url: '/cvs'
  },
  // {
  //   icon: 'https://files.wondercv.com/PC/cvs/nav/icon.png',
  //   name: '职业规划',
  //   flag: false,
  //   tipsIcon:'https://files.wondercv.com/pc/jobscan/jobscan-new-icon1.png',
  //   alertType: "planning"
  // },
  // {
  //   icon: img3,
  //   name: '求职信 Cover Letter',
  //   flag: false,
  //   url: '/cover_letters'
  // },
  // {
  //   icon: require('@/assets/image/sidebar/003.png'),
  //   name: '大牛简历分享',
  //   flag: false,
  //   alertType: 'applets'
  // },
  {
    icon: 'https://files.wondercv.com/more-muban-icon.png',
    name: '更多模板案例',
    url: '/jianlimoban',
    target: '_blank',
    flag: false
  },
  {
    icon: 'https://files.wondercv.com/pc/pannel/favorite.png',
    name: '收藏模板',
    flag: true,
    push: true,
    url: '/cvs/favorite'
  },
  {
    icon: 'https://files.wondercv.com/pc/pannel/trash.png',
    name: '回收站',
    flag: false,
    push: true,
    url: '/cvs/trash'
  },
  // {
  //   iconClass: 'iconeye',
  //   name: '简历申请通知',
  //   flag: true,
  //   push: true,
  //   url: '/inbox',
  //   num: 11
  // }

];
const menu2 = [
  {
    icon: 'https://files.wondercv.com/hr-icon.png',
    name: 'HR 邀约',
    flag: true,
    push: true,
    url: '/inbox',
    num: 0
  },
  // {
  //   icon: img1,
  //   name: '职业测试',
  //   flag: false,
  //   url: 'https://www.jiandanxinli.com/activity/wonder_cv',
  //   target: '_blank',
  //   isNew: true
  // },
  // {
  //   iconFont: "iconmail",
  //   name: '求职邮箱',
  //   flag: false,
  //   url: '/emails/my'
  // },
  {
    icon: img2,
    name: 'GPA 计算器',
    flag: false,
    alertType: 'gpa'
  },
  {
    icon: 'https://files.wondercv.com/pc/pannel/cvs-buyDetailBk-icon2.png',
    name: '春招必备',
    flag: false,
    target: '_blank',
    url: 'https://www.xiaozao.org/act2/resume?channel=119924',
    // tipsIcon:'https://files.wondercv.com/pc/pannel/cvs-buyDetailBk-icon.png'
  },
  {
    icon: 'https://files.wondercv.com/pc/jobscan/jonscan-init.png',
    name: '简历匹配度检测',
    flag: false,
    target: '_blank',
    url: '/jobscan/index',
    tipsIcon:'https://files.wondercv.com/pc/jobscan/jobscan-new-icon1.png'
  },
];
const images = [
  'https://files.wondercv.com/stu-temp-cn@2x.png',
  'https://files.wondercv.com/stu-temp-en@2x.png',
  'https://files.wondercv.com/white-temp-cn@2x.png',
  'https://files.wondercv.com/white-temp-en@2x.png',
  'https://files.wondercv.com/bank-temp-cn@2x.png',
  'https://files.wondercv.com/bank-temp-en@2x.png',
  'https://files.wondercv.com/aboard-temp-en@2x.png',
  'https://files.wondercv.com/aboard-ba-temp-en@2x.png',
  'https://files.wondercv.com/zero-temp-cn@2x.png',
  'https://files.wondercv.com/zero-temp-en@2x.png',
  'https://files.wondercv.com/develop-temp-cn@2x.png',
  'https://files.wondercv.com/product-temp-cn@2x.png',
  'https://files.wondercv.com/grad-temp-cn@2x.png'
]
import {mapState} from 'vuex';
import {routerTo, dealSignatrue} from '@/assets/js/util';
import sidebarItem from '@/components/base/sidebarItem';
import api from '@/api'
import PlanningResumeSelect from "../../views/planning/components/planning-resume-select"
export default {
  name: 'sidebar',
  components: {
    sidebarItem,
    PlanningResumeSelect
  },
  data() {
    return {
      list: [],
      selectState: false
    };
  },
  computed: {
    ...mapState('cv', ['cvs']),
    ...mapState('me', ['personInfo', 'isMembership']),
    ...mapState('app', ['sidebar', 'sidebarNum', 'has_coverletter'])
  },
  created() {
    // this.$store.dispatch('cvs/getCvs');
    this.$store.dispatch('cv/getCvsList');
    // this.$store.dispatch('cvs/getTemplates');
  },
  watch: {
    has_coverletter: {
      keep: true,
      immediate: true,
      handler: async function (val) {

        let list = [];
        if (!val) {
          list = [
            [...menu1],
            [...menu2]
          ];
          // list[0].splice(1, 1);
        } else {
          list = [
            [...menu1],
            [...menu2]
          ]
        }
        this.list = list;
        try {
          let cvsBanner = await api.jobs.getBanner({position: '20'});
          if (cvsBanner.code == 1000) {
            if(cvsBanner.data.length){
              this.list[1][2].icon =  cvsBanner.data[0].image
              this.list[1][2].name = cvsBanner.data[0].title
              this.list[1][2].url =  cvsBanner.data[0].link
            }
          }
          let res = await api.test.allApply({ page_size: 10, page: 1 });
          // 给 hr邀约数 赋值
          if (res.code === 1000 && res.data.resume_hr_permission_count ) {
            list[1][0].num = res.data.new_resume_hr_permission_count - 0
          } else {
            list[1][0].num = 0
          }
          this.list = list;
        } catch (error) {

        }
      }
    }
  },
  methods: {
    newCvs(type) {
      let alertData = {
        show: true,
        type
      };
      this.$store.dispatch('app/setAlertData', alertData)
      // if (this.isMembership && this.cvs.length >= 15) {
      //   this.$message.error('超出简历数量上限，请删除无用简历后尝试');
      //   return false;
      // }
      // if (!this.isMembership) {
      //   let alertData = {}
      //   if(isCn && isEn){
      //     this.$message.error('已达简历上限，升级会员可创建多份简历');
      //     alertData = {
      //       show: true,
      //       type: 'upVip'
      //     }
      //   } else {
      //     let cvType = ''
      //     if (isCn || isEn){
      //       cvType = isCn ? 'en' : 'cn'
      //     }
      //     alertData = {
      //       show: true,
      //       type: type,
      //       cvsType: cvType
      //     };
      //   }
      //   this.$store.dispatch('app/setAlertData', alertData)
      //   return false;
      // } else {
      //   if(this.cvs.length >= 15){
      //     this.$message.error('已达简历上限，升级会员可创建多份简历');
      //   }else {
      //
      //   }
      // }
    },
    routerTo(type, url, push, target) {
      if(type === 'planning'){
        let list = this.cvs.filter(item => item.lang == 'cn')
        if(list.length > 1){
          this.selectState = true
        }else if(list.length === 1){
          api.planning.getExperience(list[0].token).then(res=>{
            if(res.code === 1000 && (res.data.edus.length > 0 || res.data.works.length > 0)){
              routerTo(`/planning/${list[0].token}/index`, '_blank')
            }else {
              this.$message.error(res.code === 1000 ? "请补充教育经历和工作经历后再进入" : res.message)
            }
          })
        }else if(list.length === 0 && this.cvs.length > 0){
          this.$message.error('创建中文简历后再进入')
        }else if(list.length === 0 && this.cvs.length === 0){
          this.$message.error('创建简历后再进入')
        }

        return
      }
      if (type) {
        let alertData = {
          show: true,
          type
        }
        this.$store.dispatch('app/setAlertData', alertData)
        return false;
      }
      if (push && url && url !== this.$route.path) {
        routerTo(url);
        return false;
      }
      if (!push && url) {
        routerTo(url, target);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ul, li, ol {
    list-style: none;
  }
  .sidebar-main {
    width: 272px;
    .menu {
      width: 100%;
      background: #fff;
      margin-bottom: 24px;
      border-radius: 4px;
      overflow: hidden;
      &:last-child {
        margin-bottom: 0;
      }
      .list {
        width: 100%;
        height: 64px;
        border-bottom: 1px solid #EEF0F5;
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        &:last-child {
          border: none;
        }
        img {
          width: auto;
          max-width: 36px;
          max-height: 36px;
          margin-left: 19px;
          margin-right: 14px;
        }
        &.flag::after {
          content: "";
          display: block;
          width: 3px;
          height: 26px;
          background: #FF453C;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
      .item {
        height: 80px;
        display: flex;
        align-items: center;
        position: relative;
        &:first-child {
          height: 79px;
          img {
            margin-top: 0px;
          }
        }
        img {
          width: 36px;
          margin-left: 16px;
          margin-top: -1px;
        }
        .con {
          font-size: 14px;
          margin-left: -2.5px;
          .title {
            color: #404040;
            margin-top: 0px;
          }
          .msg {
            font-size: 12px;
            color: #9c9c9c;
            margin-top: 10px;
          }
        }
        .iconfont {
          color: #6c6c6c;
          font-size: 20px;
          font-weight: 400;
          position: absolute;
          top: 50%;
          right: 9px;
          transform: translateY(-50%);
        }
      }
    }
    .menu > .list.item:hover .title {
      font-weight: 600;
    }
    ::v-deep .sidebar-item-main:hover .left-model > div {
      font-weight: 600;
    }
  }
</style>
